export default __webpack_public_path__ + "static/media/494.fc18e48f.png";